import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/zhenduan.png'
import _imports_1 from '@/assets/weixiu.png'
import _imports_2 from '@/assets/jiancha.png'
import _imports_3 from '@/assets/menxian.png'


const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "w-full p-5 text-center" }
const _hoisted_3 = { class: "text-red-600 text-3xl" }
const _hoisted_4 = { class: "w-full p-5" }
const _hoisted_5 = {
  class: "box mt-4",
  style: {"width":"100%"}
}
const _hoisted_6 = {
  key: 0,
  class: "flex items-center"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "ml-2" }
const _hoisted_12 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = {
  style: {"width":"100%","text-align":"center"},
  class: "mt-4"
}

import { computed, onMounted, ref } from "vue";
import request from "../../common/request";
import { v4 as uuidv4 } from "uuid";
import dayjs from 'dayjs';
import { langList } from "@/common/lang";
import { convertConditionToLevel, getRealFactoryIdList, getGroupName } from "@/common/tools";
import { getLanguage, getTranslation, getChineseFt } from "@/common/translate";

export default /*@__PURE__*/_defineComponent({
  __name: 'warning-popup',
  emits: ['confirm', 'alarm'],
  setup(__props, { emit: __emit }) {

const getLang = () => {
   language.value = 'English'
  langObj.value = langList[language.value]
}
let langObj: any = ref({})
let language: any = ref('English')
getLang()

let typeList = [
  { label: '智能诊断', value: 1 },
  { label: '门限报警', value: 4 },
]
let getDiagLang = (record) => {
  try {
    if (record.diagnosticNotes.includes('测点：')) {
      let arr = record.diagnosticNotes.split("；");
      if (arr.length > 1) {
        let s1 = arr[0].split("：");
        let s1_1 = getLanguage(s1[0]);
        let s1_2 = getTranslation(s1[1]);

        let s2 = arr[1].split("：");
        
        let s2str = getLanguage(s2[0])+'：'+s2[1].replace('超过1级阈值',getLanguage('超过1级阈值')).replace('超过2级阈值',getLanguage('超过2级阈值')).replace('超过3级阈值',getLanguage('超过3级阈值'))

        return s1_1 + "：" + s1_2 + "；"+s2str;
      } else {
        return record.diagnosticNotes
      }
    } else {
      let arr = record.diagnosticNotes.split("；").filter((p:any) => p)
      let strArr:any = []
      arr.map((d:any) => {
        let s1 = getTranslation(d.split("：")[0]);
        let s2 = d.split("：")[1]
        let s2L = s2.split("，").filter((p:any) => p)
        let s3L:any = []
        s2L.map((d:any) => {
          s3L.push(getLanguage(d)) 
        })
        let s3 = s3L.join("，")
        let s4 = s1 + "：" + s3;
        strArr.push(s4)
      })
      return strArr.join("；")
    }
  } catch (error) {
    console.log('error', error)
    return record.diagnosticNotes
  }
};

let conditionList = [
  { label: '健康', value: 0, color: '#61c08f' },
  { label: '可用', value: 1, color: '#706a00ff' },
  { label: '可用', value: 2, color: '#706a00ff' },
  { label: '警戒', value: 3, color: '#cd5f3b' },
  { label: '警戒', value: 4, color: '#cd5f3b' },
  { label: '警戒', value: 5, color: '#cd5f3b' },
  { label: '故障', value: 6, color: '#921e37' },
  { label: '故障', value: 7, color: '#921e37' },
]

let warningColumns = [
  {
    title: langObj.value['报警时间'],
    dataIndex: 'date',
  },
  {
    title: langObj.value['报警类型'],
    dataIndex: 'type',
  },
  {
    title: langObj.value['严重程度'],
    dataIndex: 'condition',
  },
  {
    title: langObj.value['区域'],
    dataIndex: 'groupName',
  },
  {
    title: langObj.value['设备'],
    dataIndex: 'machineName',
  },
  {
    title: langObj.value['报警内容'],
    dataIndex: 'diagnosticNotes',
  }
]

let factory_id = localStorage.getItem('factory_id') || '';

const emit = __emit;

let isIntervalSet = function (settings: AlarmBeepSettings) {
  return settings.level1IntervalSeconds
      || settings.level2IntervalSeconds
      || settings.level3IntervalSeconds
      || settings.thresholdLevel1IntervalSeconds
      || settings.thresholdLevel2IntervalSeconds
      || settings.thresholdLevel3IntervalSeconds
}
onMounted(async () => {
  latestAlarmTime.value = localStorage.getItem('latestAlarmTime') || '';
  if (!latestAlarmTime.value) {
    latestAlarmTime.value = dayjs().subtract(1, 'month').format('YYYY/MM/DD HH:mm:ss')
  } else if (dayjs().subtract(1, 'month').isAfter(dayjs(latestAlarmTime.value))) {
    // 超过30天未确认报警
    latestAlarmTime.value = dayjs().subtract(1, 'month').format('YYYY/MM/DD HH:mm:ss')
  }
  startAlarmTime.value = latestAlarmTime.value;
  await getFactorySettings(factory_id);
  if (!isIntervalSet(settings)) settings = new AlarmBeepSettings();
  if (settings) {
    await startFetchJob();
    startAlarmJob();
  }
});

class AlarmBeepSettings {
  level1IntervalSeconds: number = 5;
  level2IntervalSeconds: number = 5;
  level3IntervalSeconds: number = 5;

  thresholdLevel1IntervalSeconds: number = 5;
  thresholdLevel2IntervalSeconds: number = 5;
  thresholdLevel3IntervalSeconds: number = 5;
}

let latestAlarmTime = ref<string>(); // 最新报警起始时间(增量获取报警列表)
let startAlarmTime = ref<string>();  // 界面显示的报警起始时间

let existsFlags: any = {
  level1: false,
  level2: false,
  level3: false,
  thresholdLevel1: false,
  thresholdLevel2: false,
  thresholdLevel3: false,
}

let timeout: any = null;

function beep() {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    if (workflows.value?.length === 0) return;
    play();
    emit("alarm")
    clearTimeout(timeout);
  }, 500);
}

function stopPlay() {
  let audio: any = document.getElementsByClassName("music-audio")[0];
  if (!audio) return;
  audio.pause();
}

let audioPlayButton: any;

function play() {
  let audio: any = document.getElementsByClassName("music-audio")[0];
  if (!audio) return;
  audio.controls = false;
  //audio.loop = true;
  let promise = audio.play.apply(audio);
  if (promise !== undefined) {
    promise.catch((_: any) => {
      // Autoplay was prevented. This is optional, but add a button to start playing.
      if (!audioPlayButton) {
        audioPlayButton = document.createElement("button");
        audioPlayButton.innerHTML = "Play";
        audioPlayButton.addEventListener("click", function () {audio.play.apply(audio);});
        audio.parentNode?.insertBefore(audioPlayButton, audio.nextSibling)
      }
    });
  }
}

function startAlarmJob() {
  if (settings.level1IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.level1) beep();
    }, settings.level1IntervalSeconds * 1000);
  }

  if (settings.level2IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.level2) beep();
    }, settings.level2IntervalSeconds * 1000);
  }
  if (settings.level3IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.level3) beep();
    }, settings.level3IntervalSeconds * 1000);
  }
  if (settings.thresholdLevel1IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.thresholdLevel1) beep();
    }, settings.thresholdLevel1IntervalSeconds * 1000);
  }
  if (settings.thresholdLevel2IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.thresholdLevel2) beep();
    }, settings.thresholdLevel2IntervalSeconds * 1000);
  }
  if (settings.thresholdLevel3IntervalSeconds) {
    setInterval(() => {
      if (existsFlags.thresholdLevel3) beep();
    }, settings.thresholdLevel3IntervalSeconds * 1000);
  }
}

async function startFetchJob() {
  setInterval(() => {
    fetchWorkflows();
  }, 60000);
  // 等几秒让用户鼠标动一下，才能正常播放声音
  setTimeout(async () => {
    await fetchWorkflows()
    if (existsFlags.level1) beep();
    if (existsFlags.level2) beep();
    if (existsFlags.level3) beep();
    if (existsFlags.thresholdLevel1) beep();
    if (existsFlags.thresholdLevel2) beep();
    if (existsFlags.thresholdLevel3) beep();
  }, 2000);
}


async function fetchWorkflows() {
  let list = await getWorkflows();
  if (!list || list.length === 0) return;

  workflows.value.push(...list);
  for (const workflow of list) {
    let level = convertConditionToLevel(workflow.condition);
    if (!level) continue;
    if (workflow.type === 4) {
      existsFlags[`thresholdLevel${level}`] = true;
    } else {
      existsFlags[`level${level}`] = true;
    }
  }

  latestAlarmTime.value = dayjs().format('YYYY/MM/DD HH:mm:ss')
}


function confirm() {
  localStorage.setItem('latestAlarmTime', latestAlarmTime.value || "");
  startAlarmTime.value = latestAlarmTime.value || startAlarmTime.value;
  existsFlags = {
    level1: false,
    level2: false,
    level3: false,
    thresholdLevel1: false,
    thresholdLevel2: false,
    thresholdLevel3: false,
  }
  workflows.value = [];
  stopPlay()
  emit('confirm');
}

let workflows = ref<any[]>([]);
let total = computed(() => workflows.value.length);
const getWorkflows = async () => {
  let config: any = {
    params: {
      skip: 1,
      take: 1000,
      handleStatus: 1,
      factoryIds: getRealFactoryIdList(),
      typeList: [1, 4]
    },
    headers: {
      requestId: uuidv4(),
    },
  };

  if (latestAlarmTime.value) {
    config.params.begin = latestAlarmTime.value;
  }

  let result = await request.get('/api/workflows', config)
  return result?.data.list || [];
}

let settings: AlarmBeepSettings = new AlarmBeepSettings();
const getFactorySettings = async (factoryId: string) => {
  if (!factoryId) return
  const config = {
    params: { id: factoryId },
    headers: {
      requestId: uuidv4(),
    },
  };
  let res = await request.get("/api/factories/setting", config)
  if (res?.data?.alarmBeepSettings) {
    settings = res.data.alarmBeepSettings;
  } else {
    settings = new AlarmBeepSettings();
  }
};


return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getLanguage)('报警：自')) + _toDisplayString(_unref(startAlarmTime)) + _toDisplayString(_unref(getLanguage)('起，系统共报警')) + _toDisplayString(_unref(total)) + _toDisplayString(_unref(getLanguage)('条（详情见下表），请尽快处理！')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_table, {
          style: {"width":"100%"},
          size: "small",
          columns: _unref(warningColumns),
          "data-source": _unref(workflows),
          pagination: {},
          rowKey: "id"
        }, {
          bodyCell: _withCtx(({ column, text, record }) => [
            (column.dataIndex === 'type')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (text === 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[0] || (_cache[0] = [
                        _createElementVNode("img", {
                          style: {"width":"20px"},
                          src: _imports_0,
                          alt: ""
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (text === 2)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[1] || (_cache[1] = [
                        _createElementVNode("img", {
                          style: {"width":"20px"},
                          src: _imports_1,
                          alt: ""
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (text === 3)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                        _createElementVNode("img", {
                          style: {"width":"20px"},
                          src: _imports_2,
                          alt: ""
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  (text === 4)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[3] || (_cache[3] = [
                        _createElementVNode("img", {
                          style: {"width":"20px"},
                          src: _imports_3,
                          alt: ""
                        }, null, -1)
                      ])))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(langObj)[_unref(typeList).find(p => p.value === text)?.label || ""]), 1)
                ]))
              : _createCommentVNode("", true),
            (column.dataIndex === 'condition')
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createElementVNode("div", {
                    style: _normalizeStyle([{"width":"12px","height":"12px","border-radius":"50%"}, {'background': _unref(conditionList).find((p) => p.value === text)?.color}])
                  }, null, 4),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(langObj)[_unref(conditionList).find((p) => p.value === text)?.label || ""]), 1)
                ]))
              : _createCommentVNode("", true),
            (column.dataIndex === 'groupName')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(_unref(getTranslation)(_unref(getGroupName)(record?.machine?.groupId))), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'machineName')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createTextVNode(_toDisplayString(_unref(getTranslation)(text)), 1)
                ], 64))
              : _createCommentVNode("", true),
            (column.dataIndex === 'diagnosticNotes')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                  _createTextVNode(_toDisplayString(_unref(language) === 'Chinese_ft' ?  _unref(getChineseFt)(text) : _unref(getDiagLang)(record)), 1)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["columns", "data-source"])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: confirm
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(getLanguage)('确定')), 1)
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})